import { render, staticRenderFns } from "./EditUser.vue?vue&type=template&id=5df3b512&scoped=true&"
import script from "./EditUser.vue?vue&type=script&lang=ts&"
export * from "./EditUser.vue?vue&type=script&lang=ts&"
import style0 from "./EditUser.vue?vue&type=style&index=0&id=5df3b512&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df3b512",
  null
  
)

export default component.exports